export default __webpack_public_path__ + "static/media/dl-3.0cb172aa.png";